import * as React from 'react';

export interface ITableHeadRowProps {
}

interface IState {
    isOpen: boolean;
}

/**
 * Placeholder component for wrapping reasons.
 */
export default class TableHeadRow extends React.Component<ITableHeadRowProps, IState> {
    static displayName: string = 'TableHeadRow';

    render () {
        return this.props.children;
    }
}
